
import { SCondition, RequestQueryBuilder } from '@nestjsx/crud-request';
import {Injectable} from '@angular/core';
import {Burly} from 'kb-burly';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ManyResponse} from '../../../responses/many.response';
import {BaseUnit} from '../models';

@Injectable({
  providedIn: 'root'
})
export class TorchLoanBorrowService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public queryUnits(pageSize: number = 50,
                    currentPage: number = 0,
                    sortDirection: 'ASC' | 'DESC' | '' = 'DESC',
                    sortBy: string = 'blDate',
                    filters: SCondition | null): Observable<ManyResponse<BaseUnit>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection) {
      qb.sortBy({ field: sortBy, order: sortDirection });
    }

    if (!!filters) {
      qb.search(filters);
    }

    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/loan-borrow')
      .appendRawQueryString(qb.query(false))
      .get;

    return this.httpClient.get<ManyResponse<BaseUnit>>(endpoint);
  }

  public getDistinctStations(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/loan-borrow')
      .addSegment('/stations')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ BL_STA: string }]>(endpoint).pipe(
      map(response => response.map(v => v.BL_STA))
    );
  }

  public getDistinctAirlines(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/loan-borrow')
      .addSegment('/airlines')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ BL_AIRLINE_NAME: string }]>(endpoint).pipe(
      map(response => response.map(v => v.BL_AIRLINE_NAME))
    );
  }

}
